import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/menus"
    exact
    path="/business/menus"
    component={AsyncPage}
  />,
];
